<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card elevation="0" min-height="300px">
        <v-form v-model="valid" ref="orderForm">
          <v-card-title>
            Order Process &nbsp;
            <v-chip v-if="itemId != 0" color="primary">{{itemId}}</v-chip>
            <v-chip  color="primary" class="ml-3">{{branch.branchName}}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-row>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="order.osDto.osId"
                      :items="os"
                      name="onlineShop"
                      autocomplete="off"
                      label="Restaurant"
                      item-value="osId"
                      item-text="name"
                      prepend-icon="shopping_basket"
                      :rules="townshipRule"
                      hide-details
                      dense
                    >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in">
                        <v-icon color="primary" @click="clickUserAdd()">add_circle</v-icon>
                      </v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                          v-model="restName"
                          label="Restaurant Name*"
                          prepend-icon="person"
                          required
                          dense
                        ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                          v-model="restPhone"
                          label="Restaurant Phone*"
                          prepend-icon="phone"
                          required
                          dense
                        ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                          v-model="restAddress"
                          label="Restaurant Address*"
                          prepend-icon="location_city"
                          required
                          dense
                          @keyup.enter="clickSaveOrUpdate()"
                        ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" md="2" >
                      <v-btn  icon color="black" @click="clickLocationSave(restlocation)">
            <v-icon>save</v-icon></v-btn>
                      <v-btn  icon color="primary" @click="clickLocation(restlocation)">
            <v-icon>location_on</v-icon></v-btn>
                    </v-col>
                  <v-col cols="12" md="10">
                      <v-text-field v-model="restlocation"
                          label="Restaurant Location"
                          required
                          dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-menu
                      v-model="collectDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="order.requestDate"
                          label="Request Date to Collect *"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          required
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="requestDate" @input="collectDateMenu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-row no-gutters>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="order.code"
                          label="Invoice No."
                          prepend-icon="copyright"
                          required
                          dense
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" class="pl-2">
                        <v-btn color="primary" outlined @click="clickSaveOrUpdate()">{{saveOrupdate}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- <v-col cols="12" md="6">
                    <v-textarea
                      v-model="order.orderRemark"
                      label="Remark"
                      rows="3"
                      prepend-icon="description"
                      dense
                    />
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pl-2">
                <!-- <v-alert border="left" colored-border color="black" elevation="1">
                  <ul>
                    <li>Date : {{order.date | formatDateTime($moment)}}</li>
                    <li>ModifiedDate : {{order.modifiedDate | formatDateTime($moment)}}</li>
                  </ul>
                </v-alert> -->
<v-simple-table
      :fixed-header="true" dense class="elevation-1" height="39vh">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center white--text primary">No.</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Name</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Phone</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Address</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr 
           v-for="(item,index) in order.restList" :key="index" :style="{backgroundColor: (item.saveOrUpdate == 'd' || item.saveOrUpdate == 'dd' ? 'red' : 'transparent' ) }">
           <td class="text-center">{{ item.restNo }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td >{{ item.restName }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-right">{{ item.restPhone}}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-right" >{{ item.restAddress}}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-center">
              <v-btn small icon color="green" @click="clickEdit(item)">
            <v-icon>edit</v-icon></v-btn>
            <v-btn small icon color="red" @click="clickDelete(item)" v-if="item.restNo!=1">
            <v-icon>delete</v-icon></v-btn>
            </td>
          </tr>
          <v-divider></v-divider>
        </tbody>
      </template>
 </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="order.itemId == 0" @click="beforeSaveOrder">
              <v-icon>save</v-icon>Next
            </v-btn>
            <v-btn color="primary" v-else @click="beforeUpdateOrder">
              <v-icon>edit</v-icon>Next
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialogDelete"
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h5">
          Do you want to delete?
        </v-card-title>
        <v-card-text>{{deleteOs.restNo}} - {{deleteOs.restName}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="clickDeleteOs()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col>
      <v-bottom-sheet v-model="dialogUser" fullscreen scrollable>
        <v-sheet class="information-window-v-sheet">
          <user-dialog @exist="exist()"/>
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
  </v-row>
</template>
<script>
import branchService from "../service/BranchService";
import shopService from "../service/ShopService";
import onlineshoppingService from "../service/OnlineshoppingService";
import UserDialog from './UserDialog.vue';
export default {
  components: { UserDialog },
  mounted: function () {
    shopService.AXIOS.all([
      branchService.getAllBranch(),
      shopService.getAllShop(),
    ]).then(
      shopService.AXIOS.spread((listBranch, listShop) => {
        // this.fromBranch.push(...listBranch);
        // this.toBranch.push(...listBranch);
        this.os.push(...listShop);
        this.loadOrder();
      })
    );
    branchService
          .getBranchesUser()
          .then((data) => {
            console.log("data");
            console.log(data);
            this.branch = data;
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
  },
  data: () => {
    return {
      fromBranch: [],
      toBranch: [],
      os: [],
      toTownship: [],
      collectDateMenu: false,
      branchRule: [(v) => !!v || "Branch is required"],
      townshipRule: [(v) => !!v || "Township is required"],
      valid: false,
      index:0,
      saveOrupdate:"SAVE",
      restName:"",
      restPhone:"",
      restAddress:"",
      restlocation:"",
      deleteOs:{},
      dialogDelete:false,
      branch:{},
      dialogUser:false
    };
  },
  props: {
    itemId: Number,
    order: {
      type: Object,
      default: () => ({
        itemId: {
          type: Number,
          default: 0,
        },
        fromBranchDto: {
          branchId: {
            type: Number,
            default: 0,
          },
        },
        toBranchDto: {
          branchId: {
            type: Number,
            default: 0,
          },
        },
        osDto: {
          osId: {
            type: Number,
            default: 0,
          },
        },
        townshipDto: {
          townshipId: {
            type: Number,
            default: 0,
          },
        },
        requestDate: {
          type: String,
          default: "",
        },
        date: {
          type: String,
          default: "",
        },
        modifiedDate: {
          type: String,
          default: "",
        },
        orderRemark: {
          type: String,
          default: "",
        },
      }),
    },
    loadOrder: Function,
    saveOrder: Function,
    updateOrder: Function,
  },
  computed: {
    requestDate: {
      set(value) {
        this.order.requestDate = this.$moment(
          this.$moment(value, "YYYY-MM-DD")
        ).format("DD-MM-YYYY");
      },
      get() {
        if (this.order != null && this.order.requestDate == "") {
          return this.order.requestDate;
        }
        return this.$moment(
          this.$moment(this.order.requestDate, "DD-MM-YYYY")
        ).format("YYYY-MM-DD");
      },
    },
  },
  methods: {
    exist:function(){
      this.dialogUser = false;
      shopService.AXIOS.all([
      branchService.getAllBranch(),
      shopService.getAllShop(),
    ]).then(
      shopService.AXIOS.spread((listBranch, listShop) => {
        // this.fromBranch.push(...listBranch);
        // this.toBranch.push(...listBranch);
        this.os.push(...listShop);
        this.loadOrder();
      })
    );
    },
    clickUserAdd:function(){
      this.dialogUser = true;
    },
    clickLocationSave:function(latitude){
      onlineshoppingService
          .getOsLocation(this.order.osDto.osId,latitude)
          .then(() => {
            this.$swal({
     title: "Successful",
     text: "Onlineshopping Successful!",
     type: "success",
     timer: 500
     });
          })
          .catch(err => {
              this.$swal("Failed", err.response.data.message, "error");
          });
    },
    clickLocation:function(item){
        window.open(item, "_blank");
    },
    clickEdit:function(items){
        this.deleteOs = items;
       this.order.osDto.osId = items.osId;
       this.restName = items.restName;
       this.restPhone = items.restPhone;
       this.restAddress = items.restAddress;
       this.restlocation = items.restlocation;
       this.saveOrupdate = "UPDATE";
    },
    clickDeleteOs:function(){
        var tempList = [];
    tempList.push(...this.order.restList);
    this.order.restList.splice(0);
    var no = 0;
    for(var i=0;i<tempList.length;i++){
      var tempObj = tempList[i];
      if(tempObj.restNo!=this.deleteOs.restNo){
          no = no+1;
          tempObj.restNo = no;
          this.order.restList.push(tempObj);
      }else{
        if(this.deleteOs.restaurantId>0){
          no = no+1;
          tempObj.restNo = no;
          tempObj.saveOrUpdate = "d";
          this.order.restList.push(tempObj);
        }
      }
    }
    this.saveOrupdate = "SAVE";
    this.dialogDelete = false;
    },
     clickDelete:function(item){
          this.dialogDelete = true;
          this.deleteOs = Object.assign({},item);
        },
    clickSaveOrUpdate:function(){
      if(this.saveOrupdate == "SAVE"){
          var tempRest = {};
          tempRest.restNo = this.order.restList.length+1;
          tempRest.osId = this.order.osDto.osId;
          tempRest.restName = this.restName;
          tempRest.restPhone = this.restPhone;
          tempRest.restAddress = this.restAddress;
          tempRest.restlocation = this.restlocation;
          tempRest.saveOrUpdate = "s";
          this.order.restList.push(tempRest);
      }else{
          this.deleteOs.osId = this.order.osDto.osId;
          this.deleteOs.restName = this.restName;
          this.deleteOs.restPhone = this.restPhone;
          this.deleteOs.restAddress = this.restAddress;
          this.deleteOs.restlocation = this.restlocation;
          if(this.deleteOs.restaurantId!=0){
             this.deleteOs.saveOrUpdate = "u";
          }
      }
          this.saveOrupdate = "SAVE";
    },
    loadTownship: function (event) {
      // let branchId = event;
      // townshipService.getTownshipByBranchId(branchId).then((data) => {
      //   this.toTownship.splice(0, this.toTownship.length);
      //   this.toTownship.push(...data);
      //   if(this.order.itemId == 0)
      //   this.order.townshipDto.townshipId = this.toTownship[0].townshipId;
      // });
    },
    beforeSaveOrder: function () {
      this.order.toBranchDto.branchId = this.branch.branchId;
      this.order.fromBranchDto.branchId = this.branch.branchId;
      if(this.order.restList.length<=0){
          var tempObj = {};
          tempObj.restNo = 1;
        tempObj.osId = this.order.osDto.osId;
        tempObj.restName = this.restName;
        tempObj.restPhone = this.restPhone;
        tempObj.restAddress = this.restAddress;
        tempObj.restlocation = this.restlocation;
        tempObj.saveOrUpdate = "s";
        this.order.restList.push(tempObj);
      }
      this.$refs.orderForm.validate();
      if (this.valid) {
        this.saveOrder();
      }
     // }
    },
    beforeUpdateOrder: function () {
      this.order.toBranchDto.branchId = this.branch.branchId;
            this.order.fromBranchDto.branchId = this.branch.branchId;
      if(this.order.restList.length>0){
      this.$refs.orderForm.validate();
      if (this.valid) {
        this.updateOrder();
      }
      }
    },
  },
  watch: {
    "order.toBranchDto.branchId": function (value) {
      this.loadTownship(value);
    },
    "order.fromBranchDto.branchId": function () {
      //this.loadTownship(value);
      if(this.order.itemId == 0)
      this.order.toBranchDto.branchId = this.order.fromBranchDto.branchId;
    },
    "order.osDto.osId":function(value){
      //if(this.index!=0 || this.order.itemId==0){
      const valOs = this.os.find((item) => {
                return item.osId === value;
              });
      this.restName = valOs.name;
      this.restPhone = valOs.phone;
      this.restAddress = valOs.address;
      this.restlocation = valOs.latitude;
      //}
      //this.index = 1;
    }
  },
};
</script>
<style scoped>
.login-full {
  height: 81vh;
}
.fullscreen {
  height: 81vh;
}
.v-data-table td,
.v-data-table th {
  padding: 0 0px !important;
}

.information-window-v-sheet {
  height: 100vh !important;
  overflow-x: scroll;
}
</style>